import React from 'react';

import styles from './styled-tasks-components.module.scss';
export const Strip = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['strip']} ${className}` : styles['strip']} {...props} />
);

export const Left = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['left']} ${className}` : styles['left']} {...props} />
);

export const Wrapper = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={className ? `${styles['wrapper']} ${className}` : styles['wrapper']} {...props} />
);

export const CustomAvatar = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['custom-avatar']} ${className}` : styles['custom-avatar']}
    {...props}
  />
);

export const TaskTrigger = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['task-trigger']} ${className}` : styles['task-trigger']}
    {...props}
  />
);

// Was `styled(TaskTrigger)`: renders TaskTrigger and layers its own class on
// top, so both rule sets apply exactly as before.
export const FilterTrigger = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <TaskTrigger
    className={className ? `${styles['filter-trigger']} ${className}` : styles['filter-trigger']}
    {...props}
  />
);

export const FilterTitle = ({ className, ...props }: React.ComponentPropsWithoutRef<'span'>) => (
  <span
    className={className ? `${styles['filter-title']} ${className}` : styles['filter-title']}
    {...props}
  />
);

export const LowContrastText = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'span'>) => (
  <span
    className={
      className ? `${styles['low-contrast-text']} ${className}` : styles['low-contrast-text']
    }
    {...props}
  />
);
